import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import { useLocation } from "react-router-dom";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import printerimg from "../../../../assets/print.png";
import {
  useGetItemDetailsDataMutation,
} from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import FileAttachmentManagerViewPage  from "../../../../Components/FileAttachmentManagerViewPage";
import Attachment from "../../../../utils/Attachment";
const ViewForm = () => {

  const location = useLocation();
  const IdData = location.state?.ItemId;
  const [podata, setpodata] = useState('')
  console.log('ids:', IdData)
  const navigate = useNavigate();
  const [tab, settab] = useState(1);
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);



  // tab1
  const [ItemGroupName, setItemGroupName] = useState("");
  const [select_ParentItemGroup, setselect_ParentItemGroup] = useState("");
  const [ParentItemGroup_list, setParentItemGroup_list] = useState([]);
  const [UnicommerceProductCategoryCode, setUnicommerceProductCategoryCode] =
    useState("");
  const [IsGroup, setIsGroup] = useState("");

  const [selected_default_item_data, setselected_default_item_data] =
    useState([]);
  const [selected_tax_item_data, setselected_tax_item_data] =
    useState([]);

  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
    ItemGroupName: false,
    UnicommerceProductCategoryCode: false,
  });
  const [AttachmentsList, setAttachmentsList] = useState([]); // ✅ Make sure it's an array
  const [status, setStatus] = useState("");
  const [itemDetails, { data, isLoadin }] = useGetItemDetailsDataMutation();

  useEffect(() => {
    if (IdData) {
      itemDetails({ doctype: 'Item Group', name: IdData })
        .unwrap()
        .then((response) => {
                  const item = response.docs?.[0]; // ✅ safely access first item
  const docinfo = response.docinfo;

  if (!item) return;
                    setpodata(response)
                    console.log(item, "Api response");
                    setItemGroupName(item.item_group_name);
                    setselect_ParentItemGroup(item.parent_item_group);
                    setUnicommerceProductCategoryCode(item.custom_unicommerce_item);
                    setIsGroup(item.is_group);
                    setselected_default_item_data(item.item_group_defaults)
                    setselected_tax_item_data(item.taxes)
                    // console.log("r1:",iteme.item_group_defaults);
                   setStatus(item.is_group)
                   setAttachmentsList(docinfo.attachments); // ✅ Correct place
                })
        .catch((err) => {
          console.error('API Error:', err);
        });
    } else {
      console.warn('No Id Data found in location state');
    }
  }, [IdData, itemDetails]);



  return (
    <FormLayout
      title="View Item Group"
      breadcrumbs={[
        { label: "Item Group" },
        { label: "Item Group List", url: "/master/itemgroup/item-group-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          {/* <Button
            to="/master/itemgroup/item-group-list"
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrFormPrevious"
            iconSize={12}
          >
            Back
          </Button> */}

          <Button
            to="/"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(1);
                  }}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

            {/* <FileAttachmentManagerViewPage
  doctype="Item Group"
  docname={IdData}
  attachments={AttachmentsList}
  setAttachments={setAttachmentsList}
/> */}


            <Attachment doctype="Item Group"  docname={IdData}  /> 

          </div>
        </div>

        <div
          className="mt-2"
          style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}
        >
          <div
            className="mt-2 py-2"
            style={{
              width: "100%",
              overflow: "hidden",
              backgroundColor: "#fff",
            }}
          >
            <div className="row d-flex justify-content-between">
              <div className="col-12">
                <div className="sidebarbox m-0 px-4 py-2">
                  <Tab1
                    ItemGroupName={{
                      ItemGroupName: ItemGroupName,
                      setItemGroupName: setItemGroupName,
                      ItemGroupName: ItemGroupName,
                      Error: fieldErrors.ItemGroupName,
                    }}
                    ParentItemGroup={{ ParentItemGroup_list: ParentItemGroup_list, setselect_ParentItemGroup: setselect_ParentItemGroup, select_ParentItemGroup: select_ParentItemGroup, Error: fieldErrors.ParentItemGroup }}
                    UnicommerceProductCategoryCode={{
                      UnicommerceProductCategoryCode:
                        UnicommerceProductCategoryCode,
                      setUnicommerceProductCategoryCode:
                        setUnicommerceProductCategoryCode,
                      Error: fieldErrors.UnicommerceProductCategoryCode,
                    }}
                    IsGroup={{
                      IsGroup: IsGroup,
                      setIsGroup: setIsGroup,
                      Error: fieldErrors.IsGroup,
                    }}
                  />
                  <Tab2
                    selected_default_item_data={selected_default_item_data} setselected_default_item_data={setselected_default_item_data}
                  />
                  <Tab3
                    ItemGroupName={{
                      ItemGroupName: ItemGroupName,
                      setItemGroupName: setItemGroupName,
                      ItemGroupName: ItemGroupName,
                      Error: fieldErrors.ItemGroupName,
                    }}
                    setselected_tax_item_data={setselected_tax_item_data} selected_tax_item_data={selected_tax_item_data}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default ViewForm;
